<template>
  <span>
    <span v-if="businessType !== ''">{{ businessType }} ({{ country }})</span>
    <i
      v-else
      class="fa fa-question-circle"
      data-toggle="tooltip"
      data-placement="top"
      :title="$t('Information is not available')"
    />
  </span>
</template>

<script>
export default {
  props: {
    country: {
      type: String,
      required: true,
    },

    businessType: {
      type: String,
      required: true,
    },
  },
}
</script>
